export const COLUMN_WIDTH_STATUS = 141;
export const COLUMN_WIDTH_CANDIDATES = 137;
export const COLUMN_WIDTH_CANDIDATE_MATCHES = 172;
export const COLUMN_WIDTH_PERFORMANCE = 164;
export const COLUMN_WIDTH_CTA = 188;
export const COLUMN_WIDTH_ACTIONS = 170;
export const COLUMN_WIDTH_DRAFT_TITLE = 895;

export const EmDash = '–';
